import ActivityFeed from '@app/components/ActivityFeed'
import FeedItemEditor from '@app/components/FeedItemEditor'
import { FeedItemSourceType } from '@app/models/enums'
import * as React from 'react'
import { PipelinePageProps } from './PipelinePage'

export default class PipelineActivity extends React.PureComponent<
  PipelinePageProps
> {
  public render() {
    return (
      <div key={this.props.pipeline.listing.property.id}>
        <div className='mx-2'>
          <FeedItemEditor
            contextId={this.props.pipeline.listing.property.id}
            contextType={FeedItemSourceType.Property}
          />
        </div>
        <ActivityFeed contextId={this.props.pipeline.listing.property.id} />
      </div>
    )
  }
}
